import * as calendarType from "../../actiontype/CalendarType/CalendarType.jsx";
import { deleteReq, get, post, put } from "../../../../common/utils/index.js";


export const AddCalendar = (payload,setIsSuccess,setIsModalOpen,pharmacyList) => (dispatch) => {
  dispatch({ type: calendarType?.CALENDAR_ADD_REQUEST });
  post(`/Pharmacy/Calendar`, payload )
    .then((res) => {
      dispatch({
        type: calendarType?.CALENDAR_ADD_SUCCESS,
        payload: res.data,
      });
      dispatch(getByPharmacyIdCalendar(pharmacyList.pharmacyListID))

      setIsSuccess(true);
      setIsModalOpen(false);
      // AddCalendarData.showToast('success',AddCalendarData.t('text_toast_success'), res?.response?.data?.message)
      pharmacyList?.showToast("success","Attenzione",(res?.message));
      // showToast('success', dataTrans('text_toast_success'), res?.response?.data?.message);  
    })
    .catch((err) => {
      // AddStructureData.hideLoader();
      pharmacyList?.showToast(
        "warn",
        "Attenzione",
        (err?.message)
      );
      dispatch({
        type: calendarType.CALENDAR_ADD_FAILURE,
        payload: err?.message,
      });
      // AddCalendarData.showToast("warn","Attenzione",AddCalendarData.t(err?.response?.data?.message));
    });
};


  
    export const getByPharmacyIdCalendar = (id) => (dispatch) => {
      // showLoader();

  
      dispatch({ type: calendarType.HOSPITAL_PHARMACY_CALENDAR_REQUEST })
      get(`Pharmacy/Calendar/${id}`)
        .then(res => {
          dispatch({ type: calendarType.HOSPITAL_PHARMACY_CALENDAR_SUCCESS, payload: res?.data })})
        .catch(err => {

  
          dispatch({ type: calendarType.HOSPITAL_PHARMACY_CALENDAR_FAILURE, payload: err?.response?.data?.message })
          // showToast('warn', 'Attenzione', dataTrans(err?.response?.data?.message));
        })
    }

    // calendar update

    export const updatePharmacyCalendar = (updateCalendar,setIsModalOpen) => (dispatch) => {
      dispatch({ type: calendarType.CALENDAR_UPDATE_REQUEST });
      // put(`/HospitalFacility/Calendar/${UpdatePharmacyData?.id}`, UpdatePharmacyData.payload, UpdatePharmacyData.headers)
      put(`/pharmacy/calendar/${updateCalendar?.ID}`, updateCalendar.payload, updateCalendar.headers)
        .then((res) => {
          dispatch({
            type: calendarType.CALENDAR_UPDATE_SUCCESS,
            payload: res.data,
          });
          updateCalendar?.showToast('success', updateCalendar.t('text_toast_success'), updateCalendar.t(res?.response?.data?.message));
          setIsModalOpen(false);
          dispatch(getByPharmacyIdCalendar(updateCalendar?.id))
        })
        .catch((err) => {
          updateCalendar?.showToast('warn', 'Attenzione', updateCalendar.t(err.message));
          dispatch({
            type: calendarType.CALENDAR_UPDATE_FAILURE,
            payload: err?.message,
          });
          
        });
    };